/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'

import {accounting} from 'accounting'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class TransferCostByProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      loading: false,
      reportTransferCost: [],
      total: '',
      printInfo: [],
      grouping: '',
      fromDate: '',
      toDate: '',
      providers: [],
      providerId: '',
      aggregation: {},
      buttonClicked: false,
      providerIdObject: [],
      providerIds: [],
      warehouses: [],
      warehousesObjects: [],
      warehouseIds: []
    }
  }
  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error === null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name
          }
          this.setState({
            warehouses: response.data.object
          })
        } else {
          this.setState({
            warehouses: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }

  onResultFetched(data) {
    this.setState({
      reportTransferCost: data
    })
  }

  changeDropDown(data) {
    this.setState({
      reportTransferCost: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  changeGrouping = (e) => {
    let target = e.target

    this.setState({
      grouping: target.options[target.selectedIndex].text
    })
  }

  filter() {
    var productGrouping = document.getElementById('productGrouping').value
    let {providerIds, warehouseIds, providerId} = this.state
    var minDate = this.state.fromDate
    var maxDate = this.state.toDate
    if (productGrouping === '' && !providerId && warehouseIds.length === '0' && minDate === '' && maxDate === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        loading: true
      })
      sessionStorage.setItem(
        'params',
        `productGrouping=${productGrouping}&providerIds=${providerId}&warehouseIds=${warehouseIds}&planDateMin=${minDate}&planDateMax=${maxDate}&sortBy=providerId_asc`
      )
      sessionStorage.setItem('pageNumber', 1)
      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER
          }?export=false&pageNumber=1&pageSize=10&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error === null) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              reportTransferCost: response.data.object.result,
              total: response.data.object.countAll,
              getGrouping: this.state.grouping,
              aggregation: response.data.object.aggregation,

              printFromTime: this.state.fromDate === '' ? '' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              printToTime: this.state.toDate === '' ? '' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              reportTransferCost: [],
              loading: false
            })
            // message.error(response.data.description)
          }
        })
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getValueProvider = (providerIdObject) => {
    var providerArr = []
    this.setState({
      providerIdObject
    })
    if (providerIdObject.length == '0') {
      this.setState({
        providerIds: []
      })
    } else {
      for (let prop of providerIdObject) {
        providerArr.push(prop.providerId)
        this.setState({
          providerIds: providerArr
        })
      }
    }
  }
  getValueWarehouse = (warehouseObject) => {
    var warehouseArr = []
    this.setState({
      warehouseObject
    })
    if (warehouseObject.length == '0') {
      this.setState({
        warehouseIds: []
      })
    } else {
      for (let prop of warehouseObject) {
        warehouseArr.push(prop.id)
        this.setState({
          warehouseIds: warehouseArr
        })
      }
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation,
            loading: false
          })
        } else {
          this.setState({
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['websiteTakhfif'] = Number(excelReport[i]['websiteDiscountAmount'])
            excelReport[i]['providerTakhfif'] = Number(excelReport[i]['providerDiscountAmount'])
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  render() {
    let {loading} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reporterName = cookie.load('name')
    let printCol = ['ردیف', 'تامین کننده', 'نام محصول', 'هزینه حمل', 'تخفیف سایت', 'تخفیف تامین کننده']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش هزینه حمل.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'product.productName'}
                title={'نام محصول'}
                width="400px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'deliveryFee'}
                field={'deliveryFee'}
                title={'هزینه حمل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'websiteTakhfif'}
                field={'websiteTakhfif'}
                title={'تخفیف سایت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerTakhfif'}
                field={'providerTakhfif'}
                title={'تخفیف تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست گزارشات هزینه حمل"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={7}
              rightColSpan={4}
              centerColSpan={0}
              leftColSpan={3}
              centerSection={''}
              rightSection={
                ' گزارش بر مبنای تامین کننده ' +
                this.state.getGrouping +
                ' از تاریخ ' +
                this.state.printFromTime +
                ' تا ' +
                this.state.printToTime
              }
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.providerName}</td>
                  <td>{list.product === null ? '-' : list.product.productName}</td>
                  <td className="priceCell">{accounting.formatMoney(list.deliveryFee, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(list.websiteDiscountAmount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(list.providerDiscountAmount, '', ',')}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={3}>مجموع</td>
                <td className="priceCell">{accounting.formatMoney(this.state.aggregation.deliveryFee, '', ',')}</td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.aggregation.websiteDiscountAmount, '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.aggregation.providerDiscountAmount, '', ',')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارش هزینه حمل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER + '?export=true'}
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={false}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>بر مبنای </label>
                  <select className="form-control" onChange={this.changeGrouping} id="productGrouping">
                    <option value={true}>محصول</option>
                    <option value={false}>تامین کننده</option>
                  </select>
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={true}
                                        isDisabled={false}
                                    /> */}
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.warehouses}
                    getValueCombo={this.getValueWarehouse}
                    lableText="انبار"
                    placeholder="------"
                    isClearable={true}
                    isMulti={true}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>تامین کننده</td>
                    <td>نام محصول</td>
                    <td className="priceCell">هزینه حمل</td>
                    <td className="priceCell">تخفیف سایت</td>
                    <td className="priceCell">تخفیف تامین کننده</td>
                  </tr>
                  {this.state.reportTransferCost.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.providerName}</td>
                      <td>
                        {list.product !== null && (
                          <a target="_blank" href={productShop({articleId: list.product.articleId})}>
                            {list.product == null ? '-' : list.product.productName}
                          </a>
                        )}
                      </td>
                      <td />
                      <td className="priceCell">{accounting.formatMoney(list.deliveryFee, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(list.websiteDiscountAmount, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(list.providerDiscountAmount, '', ',')}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={3}>مجموع</td>
                    <td className="priceCell">{accounting.formatMoney(this.state.aggregation.deliveryFee, '', ',')}</td>
                    <td className="priceCell">
                      {accounting.formatMoney(this.state.aggregation.websiteDiscountAmount, '', ',')}
                    </td>
                    <td className="priceCell">
                      {accounting.formatMoney(this.state.aggregation.providerDiscountAmount, '', ',')}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_INCOMING_BYPROVIDER}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default TransferCostByProvider
